module.exports = __webpack_public_path__ + "1a1b508da4a7a8a9564c5f80a148a9e8.jpg";


/*****************
 ** WEBPACK FOOTER
 ** ./components/Aside/images/bio-nadine-01.jpg
 ** module id = 362
 ** module chunks = 0
 **/